import pDebounce from 'p-debounce';
import config from './config';

export default function getValidationFn(
  validator,
  errorMessage,
  delay
) {
  return pDebounce(async function debounceFn(value) {
    const validate = await validator(value, errorMessage);
    return validate;
  }, delay ?? config.delay);
}
